module.exports = __webpack_public_path__ + "img/ic_24_add.0dfeb735.svg";